import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/building";

export const pagingBuilding = (pageIndex, pageSize) => {
    return axios.get(API_PATH + "/" +  pageIndex + "/" + pageSize );
};

export const saveBuilding = building => {
    return axios.post(API_PATH, building);
}

export const getBuildingById = buildingId =>{
    const url = API_PATH + "/" + buildingId;
    return axios.get(url);
}

export const deleteBuildingById = buildingId =>{
    const url = API_PATH + "/" + buildingId;
    return axios.delete(url);
}